/* tslint:disable */
/* eslint-disable */
/**
 * Melco Efs APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EfsMelcoEfsModelsMappingListItem,
    EfsMelcoEfsModelsMappingListItemFromJSON,
    EfsMelcoEfsModelsMappingListItemFromJSONTyped,
    EfsMelcoEfsModelsMappingListItemToJSON,
    EfsMelcoModelsCustomWarning,
    EfsMelcoModelsCustomWarningFromJSON,
    EfsMelcoModelsCustomWarningFromJSONTyped,
    EfsMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface EfsMelcoModelsGenericList1MelcoEfsModelsMappingListItem
 */
export interface EfsMelcoModelsGenericList1MelcoEfsModelsMappingListItem {
    /**
     * 
     * @type {Array<EfsMelcoEfsModelsMappingListItem>}
     * @memberof EfsMelcoModelsGenericList1MelcoEfsModelsMappingListItem
     */
    list: Array<EfsMelcoEfsModelsMappingListItem>;
    /**
     * 
     * @type {Array<EfsMelcoModelsCustomWarning>}
     * @memberof EfsMelcoModelsGenericList1MelcoEfsModelsMappingListItem
     */
    warning_list?: Array<EfsMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof EfsMelcoModelsGenericList1MelcoEfsModelsMappingListItem
     */
    total: number;
}

export function EfsMelcoModelsGenericList1MelcoEfsModelsMappingListItemFromJSON(json: any): EfsMelcoModelsGenericList1MelcoEfsModelsMappingListItem {
    return EfsMelcoModelsGenericList1MelcoEfsModelsMappingListItemFromJSONTyped(json, false);
}

export function EfsMelcoModelsGenericList1MelcoEfsModelsMappingListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): EfsMelcoModelsGenericList1MelcoEfsModelsMappingListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(EfsMelcoEfsModelsMappingListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(EfsMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function EfsMelcoModelsGenericList1MelcoEfsModelsMappingListItemToJSON(value?: EfsMelcoModelsGenericList1MelcoEfsModelsMappingListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(EfsMelcoEfsModelsMappingListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(EfsMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


